import {
  EmailConsent,
  Paginated,
  PaginatedResponse,
  QueryArgs,
  Sortable,
} from "@ac-expo/api-types";
import { ConsentsFilter } from "../query-keys";
import { privateAxios } from "../axiosInstances";
import { isAxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import { emailsConsentsQueryKeys } from "../query-keys/emails-consents.query-keys";

const getEmailsConsents = async (
  filters?: Sortable<Paginated<ConsentsFilter>>
) => {
  try {
    const res = await privateAxios.get<PaginatedResponse<EmailConsent>>(
      `email-consents`,
      {
        params: filters,
      }
    );
    return res.data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw {
        message: error.response?.data.message,
      };
    }
    throw error;
  }
};

export const useGetEmailsConsentsQuery = (
  filters?: Sortable<Paginated<ConsentsFilter>>,
  options?: QueryArgs<PaginatedResponse<EmailConsent>>
) => {
  return useQuery({
    queryKey: emailsConsentsQueryKeys.lists(filters),
    queryFn: () => getEmailsConsents(filters),
    ...options,
  });
};
